import { IDictionary } from "..";
import { RENDERED_PAGE_COMPONENT_HEIGHT } from "./../../constants/index";

export const pt: IDictionary = {
  appName: "Pagefy",
  appDescription:
    "Pagefy é uma plataforma que permite qualquer pessoa a criar uma landing page para ser utilizada como link de uma bio em rede social, como Instagram, Twitter, LinkedIn, Facebook, TikTok, Snapchat, Kwai, dentre outros. Aqui você encontra uma alternativa ao Linktree e outros.",
  hide: "Esconder",
  activate: "Ativar",
  active: "Ativo",
  inactive: "Inativo",
  inactivate: "Desativar",
  checkOurPlans: "Confira nossos planos",
  youAreSpecial: "Você também pode ser especial!",
  ok: "OK",
  recurrency: {
    titleSingular: "Recorrência",
    titlePlural: "Recorrências",
    monthly: "Mensal",
    month: "Mês",
    yearly: "Anual",
    year: "Ano",
  },
  home: "Início",
  plans: "Planos",
  pages: "Páginas",
  theme: "Tema",
  statistics: "Estatísticas",
  support: "Suporte",
  supportDescription:
    "Entre em contato e nossa equipe irá responder o mais breve possível.",
  toGetSupport: "para ter acesso ao nosso suporte.",
  pageNotFound: "Nada por aqui!",
  getInTouch: "Entre em contato!",
  views: "Visualizações",
  image: "Imagem",
  text: "Texto",
  textImage: "Imagem & Texto",
  icon: "Ícone",
  video: "Vídeo",
  launch: "Lançamento",
  textOverImage: "Texto sobre imagem",
  unknown: "Desconhecido",
  columns: "Colunas",
  rows: "Linhas",
  clicks: "Cliques",
  type: "Tipo",
  backgroundColor: "Cor do fundo",
  fontColor: "Cor da fonte",
  fillColor: "Cor do preenchimento",
  uploadImage: "Enviar imagem",
  uploadBackgroundImage: "Enviar imagem de fundo",
  chooseEffect: "Escolher efeito",
  toggleVisibility: "Mudar visibilidade",
  makePagePublic: "Tornar página visível ao público",
  makePagePrivate: "Tornar página invisível ao público",
  remove: "Remover",
  removeExisting: "Remover existente",
  close: "Fechar",
  last: "Último",
  open: "Abrir",
  step: "Passo",
  tools: {
    button: {
      name: "Botão",
      dialogTitle: "Crie um botão",
      typeHelpText:
        "Seu botão pode ser de apenas um tipo. Pode ter apenas texto, sem imagem; pode ter tanto texto quanto imagem; ou pode ter apenas imagem. Texto sobre imagem irá colocar a imagem como plano de fundo e o texto com posição absoluta sobre o fundo.",
      typeTextOnly: "Botão contendo apenas um texto.",
      typeTextAndImage: "Botão contendo texto e imagem.",
      typeImageOnly: "Botão contendo apenas uma imagem.",
      typeTextOverImage: "Botão contendo um texto sobre uma imagem.",
      columnsHelpText:
        "Toda página pode ser dividida em até duas seções (colunas) e seu botão poderá ocupar uma (metade) ou duas delas (completo).",
      rowsHelpText: `Seu botão pode ocupar o espaço de um até 8 linhas. Multiplique o total de linhas por ${RENDERED_PAGE_COMPONENT_HEIGHT} e você terá a altura total do seu botão (em pixels).`,
      borderRadiusHelpText:
        "Seu botão poderá ter bordas com diferentes raios pré-definidos.",
      shadowHelpText: "Seu botão poderá ter diferentes sombras pré-definidos.",
      shadowStyles: {
        none: "Nenhuma",
        smooth: "Suave",
        normal: "Normal",
        hard: "Forte",
        extreme: "Extrema",
      },
    },
    icon: {
      name: "Ícone",
    },
    video: {
      name: "Vídeo",
    },
    launch: {
      name: "Lançamento",
    },
    whatsapp: {
      name: "Whatsapp",
    },
    map: {
      name: "Mapa",
      textfieldMapUrlLabel: "URL do Google Maps",
    },
    spotify: {
      name: "Spotify",
      textfieldSpotifyUrlLabel: "URL do Spotify",
    },
    progressBar: {
      name: "Barra de Progresso",
      textfieldProgressLabel: "Valor do progresso",
    },
    counters: {
      name: "Contadores",
      textfieldCounterLabel: "Contador",
      number: "Número",
      label: "Rótulo",
    },
  },
  removeIcon: "Remover Ícone",
  removeComponent: "Remover Componente",
  findingSubscriptionsHistory: "Buscando histórico de assinaturas",
  removePage: "Remover Página",
  iconName: "Nome do ícone",
  back: "Voltar",
  cancel: "Cancelar",
  confirm: "Confirmar",
  add: "Inserir",
  mountURL: "Montar URL",
  searchIconMinCaracters: "Busca precisa ter mais de 3 caracteres.",
  url: "URL",
  invalidUrl: "URL inválida",
  hasToBeYoutubeVideo: "Precisa ser uma URL de um vídeo do YouTube",
  colorPicker: "Escolha outra cor",
  pickBGColor: "Escolha uma cor de fundo",
  pickFontColor: "Escolha uma cor de fonte",
  pickBGColorUserPage: "Escolha cor de fundo da página",
  pickFontColorUserPage: "Escolha cor de fonte da página",
  removeComponentConfirmation: "Deseja realmente remover este componente?",
  removeIconConfirmation: "Deseja realmente remover este ícone?",
  removePageConfirmation: "Deseja realmente remover esta página?",
  removeUserConfirmation: "Deseja realmente excluir sua conta?",
  notAvailableInYourPlan: "Não disponível em seu plano, faça upgrade.",
  yes: "Sim",
  no: "Não",
  or: "ou",
  and: "e",
  fileHandling: {
    chooseFile: "Escolha um arquivo",
    chooseImage: "Escolha uma imagem",
    dragAndDropYourImage: "Arraste e solte sua imagem aqui",
    dropYourImageHere: "Solte sua imagem aqui...",
    fileReadyToUpload: "Arquivo pronto para enviar",
    fileDeletedSuccessfully: "Arquivo apagada com sucesso.",
    errorToDeleteFile: "Não foi possível apagar o arquivo.",
  },
  clickToSearchIt: "Clique para procurar",
  next: "Avançar",
  webSiteExample: "https://www.meusite.com",
  send: "Enviar",
  scheduleComponentVisibleDate: "Agendar visibilidade",
  scheduleComponentVisibleDateInstructions:
    "Seu link ficará visível a partir desta data.",
  save: "Salvar",
  date: "Data",
  hour: "Hora",
  time: "Horário",
  urlRequired: "URL obrigatória",
  textInComponentRequired: "Obrigatório para este componente",
  imageInComponentRequired: "Escolha uma imagem para seu componente",
  selectAllOptions: "Selecione todas as opcões!",
  videoUrl: "URL do vídeo",
  videoComponentDescription:
    "Seu vídeo ocupará 2 colunas e 2 linhas na sua página",
  youtubeUrlExample: "https://www.youtube.com/embed/Lq2lNYKYpYw",
  youtubeIdExample: "Lq2lNYKYpYw",
  youtubeIdInstructions:
    "Acesse o vídeo do YouTube que você deseja inserir na sua página e copie a URL para cá",
  mapsInstructions:
    "Localize o lugar que você quer no Google Maps, copie a URL do navegador onde o mapa está aberto e cole aqui.",
  spotifyInstructions:
    'Abra o Spotify, localize a playlist, o artista, o álbum ou a faixa que você quer, clique no "...", selecione "Compartilhar" e então "Copiar link...". Então cole a URL aqui.',
  youtubeVideoId: "ID do video do Youtube",
  clickHere: "Clique aqui",
  share: "Compartilhar",
  understood: "Entendi",
  skip: "Pular",
  invalidId: " ID inválido",
  warningPrivatePage: "Esta página não está disponível publicamente.",
  create: "Criar",
  of: "de",
  chooseOneToCreate: "Escolha uma para criar",
  createPage: "Criar Página",
  pageName: "Nome da página",
  pageUrl: "URL da página",
  requiredField: "Campo obrigatório",
  requiredFields: "Campos obrigatórios",
  pageUrlExample: "/link-unico-da-pagina",
  createPageError: {
    pageUrlBadFormat:
      "Link mal formatado. Requisitos: conter mais de 3 caracteres, letras minúsculas sem acento, sem caracteres especiais (exceto hífen) e sem espaços em branco, como no exemplo: /minha-pagina",
    cannotContainWhiteSpaces: "Não pode haver espaços em branco.",
  },
  launchMessageLabel: "Mensagem",
  launchMessageExample: "para a inauguração da nossa loja",
  launchComponentInstructions:
    "Haverá um cronômetro na sua página, acima de uma mensagem, marcando quanto tempo falta para a data e a hora informada aqui",
  launchDateTimeBeforeToday: "Precisa ser futuro",
  days: "dias",
  hours: "horas",
  minutes: "minutos",
  minutesAbbreviated: "min",
  seconds: "segundos",
  secondsAbbreviated: "seg",
  launchPrefixText: "Restam",
  chooseAnimation: "Escolher animação",
  mountWhatsappURL: "Montar URL do Whatsapp",
  selectAnOption: "Selecione uma opção",
  selectACurrency: "Selecione uma moeda",
  selectARecurrency: "Selecione uma recorrência",
  duration: "Duração",
  startDelay: "Atraso para iniciar",
  animation: "Animação",
  animationInstruction: "Simulação do seu componente",
  noAnimation: "Nenhuma animação",
  repeatInfinitely: "Repetir infinitamente",
  firstName: "Primeiro nome",
  lastName: "Sobrenome",
  name: "Nome",
  password: "Senha",
  confirmPassword: "Confirmar Senha",
  email: "E-mail",
  agreeWith: "Concordo com os",
  termsOfUse: "Termos de uso",
  terms: "Termos",
  termsOfUseSubtitle: "Entenda nossos termos de uso",
  privacyPolicies: "Políticas de Privacidade",
  privacyPoliciesSubtitle: "Entenda nossas políticas de privacidade",
  cookies: "Cookies",
  cookiesPolicies: "Políticas de Cookies",
  cookiesPoliciesSubtitle: "Entenda nossas políticas de Cookies",
  cookiesConsent:
    "Nós usamos cookies, armazenamento local, de sessão e outras tecnologias pertecentes a nós ou a terceiros para permitir o pleno, seguro e correto funcionamento do nosso site, bem como para personalizar o conteúdo para sua experiência. Também utilizamos tudo isso para analisar o comportamento do usuário e ajustar anúncios e direcionar conteúdos de acordo com os gostos e as preferências do usuário.",
  wishesCommunications: "Desejo receber comunicados por e-mail",
  register: "Cadastrar",
  registerImperative: "Cadastre-se",
  createYourAccount: "Crie sua conta",
  signUp: "Cadastrar",
  accessAccount: "Acesse sua conta",
  welcomeBack: "Bem-vindo de volta!",
  fillDataToAccessAccount: "Preencha suas credenciais para acessar sua conta!",
  fillYourPersonalData: "Preencha seus dados pessoais",
  signIn: "Entre",
  signIn2: "Entrar",
  emailExample: "email@exemplo.com",
  passwordRequirements:
    "Requisitos para a senha: \n * No mínimo 8 caracteres \n * Pelo menos 1 letra minúscula \n * Pelo menos 1 número",

  requiredPrivacyAccept:
    "Você precisa aceitar os termos de uso e as políticas de privacidade para continuar.",
  authErrors: {
    urlAlreadyExists: "URL já existe.",
    userAlreadyExists: "Usuário já existente, tente outro e-mail.",
    invalidCredentials: "Senha incorreta.",
    userNotFound: "Usuário não localizado.",
    weakPassword: "Senha fraca.",
    invalidEmail: "E-mail inválido.",
    passwordMustAttendRequirements:
      "Senha precisa atender aos requisitos mínimos.",
    invalidToken: "Erro de autenticação. Tente entrar novamente.",
    notAllowed: "Não permitido.",
    accountExistsWithDifferentCredential:
      "Conta existe, porém possui outro método de entrar. Tente novamente com o método correto.",
  },
  signInAgain: "Por favor entre novamente.",
  generalErrors: {
    errorSignUp: "Erro ao criar sua conta.",
    errorSignIn: "Erro ao entrar.",
    errorSignOut: "Erro ao sair.",
    unknownError: "Error desconhecido.",
    internalError: "Erro interno.",
    signUpNotAllowed: "Pagefy ainda não está disponível para o público.",
    unexpectedError: "Desculpe, tivemos um erro inesperado.",
  },
  subscribeErrors: {
    fetchPlan: "Erro ao buscar os detalhes do plano",
    signInToSubscribe: "Entre para efetuar a assinatura",
    activeSubscriptionFoundCancel:
      "Você possui uma assinatura ativa. Acesse seu perfil e faça o cancelamento para adquirir outra",
  },
  profile: "Perfil",
  profileSubtitle: "Verifique e atualize seus dados pessoais aqui",
  signOut: "Sair",
  noAccountYet: "Ainda não possuo conta",
  alreadyHaveAccount: "Já possuo uma conta",
  couldntFindPage: "Não foi possível localizar a página.",
  maximumFileSizeOf: "Tamanho máximo permitido do arquivo:",
  viewPage: "Visualizar página",
  duplicate: "Duplicar",
  animations: {
    bounce: "Pulo",
    bounceIn: "Pulo entrando",
    bounceInDown: "Pulo entrando para baixo",
    bounceInLeft: "Pulo entrando para a esquerda",
    bounceInRight: "Pulo entrando para a direita",
    bounceInUp: "Pulo entrando para cima",
    bounceOut: "Pulo saindo",
    bounceOutDown: "Pulo saindo para baixo",
    bounceOutLeft: "Pulo saindo para a esquerda",
    bounceOutRight: "Pulo saindo para direita",
    bounceOutUp: "Pulo saindo para cima",
    fadeIn: "Esmaecer entrando",
    fadeInDown: "Esmaecer entrando para baixo",
    fadeInDownBig: "Esmaecer entrando alto para baixo",
    fadeInLeft: "Esmaecer entrando para a esquerda",
    fadeInLeftBig: "Esmaecer entrando de longe para a esquerda",
    fadeInRight: "Esmaecer entrando para a direita",
    fadeInRightBig: "Esmaecer entrando de longe para a direita",
    fadeInUp: "Esmaecer entrando para cima",
    fadeInUpBig: "Esmaecer entrando de longe para cima",
    fadeOut: "Esmaecer saindo",
    fadeOutDown: "Esmaecer saindo para baixo",
    fadeOutDownBig: "Esmaecer saindo para longe abaixo",
    fadeOutLeft: "Esmaecer saindo para a esquerda",
    fadeOutLeftBig: "Esmaecer saindo para longe à esquerda",
    fadeOutRight: "Esmaecer saindo para a direita",
    fadeOutRightBig: "Esmaecer saindo para longe à direita",
    fadeOutUp: "Esmaecer saindo para cima",
    fadeOutUpBig: "Esmaecer saindo para longe acima",
    flash: "Piscar",
    flip: "Virar",
    flipInX: "Virar entrando no eixo X",
    flipInY: "Virar entrando no eixo Y",
    flipOutX: "Virar saindo no eixo X",
    flipOutY: "Virar saindo no eixo Y",
    headShake: "Vibrar",
    hinge: "Cair como junta",
    jello: "Distorcer",
    lightSpeedIn: "Velocidade da luz entrando",
    lightSpeedOut: "Velocidade da luz saindo",
    pulse: "Pulsar",
    rollIn: "Rolar para dentro",
    rollOut: "Rolar para fora",
    rotateIn: "Girar entrando",
    rotateInDownLeft: "Girar para baixo entrando a partir da esquerda",
    rotateInDownRight: "Girar para baixo entrando a partir da direita",
    rotateInUpLeft: "Girar para cima entrando a partir da esquerda",
    rotateInUpRight: "Girar para cima entrando a partir da direita",
    rotateOut: "Girar para fora",
    rotateOutDownLeft: "Girar para baixo saindo para a esquerda",
    rotateOutDownRight: "Girar para baixo saindo para a direita",
    rotateOutUpLeft: "Girar para cima saindo para a esquerda",
    rotateOutUpRight: "Girar para cima saindo para a direita",
    rubberBand: "Efeito elástico",
    shake: "Balançar",
    slideInDown: "Deslizar entrando para a baixo",
    slideInLeft: "Deslizar entrando para a esquerda",
    slideInRight: "Deslizar entrando para a direita",
    slideInUp: "Deslizar entrando para cima",
    slideOutDown: "Deslizar saindo para baixo",
    slideOutLeft: "Deslizar saindo para a esquerda",
    slideOutRight: "Deslizar saindo para a direita",
    slideOutUp: "Deslizar saindo para cima",
    swing: "Dançar",
    tada: "Assustar",
    wobble: "Oscilar forte",
    zoomIn: "Zoom para perto",
    zoomInDown: "Zoom para perto e para baixo",
    zoomInLeft: "Zoom  para perto e para a esquerda",
    zoomInRight: "Zoom para perto e para direita",
    zoomInUp: "Zoom para perto e para cima",
    zoomOut: "Zoom para longe",
    zoomOutDown: "Zoom para longe e para baixo",
    zoomOutLeft: "Zoom para longe e para a esquerda",
    zoomOutRight: "Zoom para longe e para a direita",
    zoomOutUp: "Zoom para longe e para cima",
  },
  recommended: "Recomendado",
  checkout: "Prosseguir",
  createNowYour: "Crie agora sua",
  page: "página",
  forYourSocialMedia: "para suas redes sociais",
  landingPage: "landing page",
  forYourProductOrBusiness: "para seu produto ou negócio",
  dependOnNoneToReleaseCreativity:
    "Dependa de NINGUÉM para liberar sua criatividade!",
  haveAccessToPremiumResources:
    "Tenha acesso a recursos premium por um baixo investimento!",
  differentiate: "Diferencie-se dos outros!",
  getAPlanNow: "Assine um plano agora!",
  subscribeNow: "Assine agora!",
  yourPlanIs: "Seu plano é",
  thePlanYouSelectedIs: "O plano selecionado foi o",
  subscribe: "Assinar",
  youreCloserNowBecomeSubscriber:
    "Você está mais perto agora de se tornar um assinante cheio de mimos",
  nowChooseTheRecurrency:
    "Agora falta apenas escolher uam recorrência (com ou sem desconto anual)",
  nowItsTimeToSubscribe: "Agora é hora de finalizar sua assinatura",
  subscription: "Assinatura",
  yourSubscriptions: "Suas assinaturas",
  noSubscriptions: "Sem assinaturas",
  subscriptionPayment: {
    succeeded: "Assinatura contratada com sucesso!",
    paymentCancelled: "Pagamento cancelado!",
    processing: "Sua assinatura está sendo processada.",
    failed:
      "Sua assinatura não pôde ser processada, por favor tente novamente.",
    declined:
      "Seu pagamento foi recusado. Por favor verifique junto ao seu banco.",
    userAbort: "Pagamento abortado. Tente novamente.",
    processingError: "Desculpe, tivemos um erro técnico.",
    somethingWentWrong: "Algo deu errado com sua assinatura.",
    cardNumberIncomplete: "Número do cartão incompleto!",
    paymentAlreadySucceeded:
      "Você não pode prosseguir com esse pagamento porque ele já foi processado com sucesso.",
    changeRecurrency: "Alterar recorrência",
    trustWarning:
      "Não se preocupe, seu pagamento será processado exclusivamente via",
    youHaveNoFinanceHistory:
      "Você não possui histórico de pagamentos ou assinaturas.",
    errorOnPaymentClientSecret:
      "Erro ao carregar pagamento. Por favor atualize a página e tente novamente.",
    subscriptionStatuses: {
      incomplete: "Incompleta",
      canceled: "Cancelada",
      paid: "Paga",
      succeeded: "Sucesso",
    },
    amountPaid: "Valor pago",
    clickHereToSeeInvoice: "Clique aqui para ver sua nota fiscal",
    cancelSubscription: "Cancelar assinatura",
    cancelSubscriptionConfirm:
      "Tem certeza que deseja cancelar sua assinatura?",
    cancelSubscriptionError:
      "Desculpe, ocorreu um erro ao cancelar sua assinatura. Tente novamente ou contate nosso suporte.",
  },
  actionCannotBeUndone: "Esta ação não poderá ser desfeita",
  typeHere: "Digite aqui",
  doYouHaveACoupon: "Possui cupom?",
  coupon: "Cupom",
  couponExample: "MEUCUPOM123",
  value: "Valor",
  upgradeYourPlan: "Aumente o nível do seu plano",
  plan: "Plano",
  freePlan: {
    name: "Free",
    benefits: [
      "Botões ilimitados",
      "Ícones ilimitados",
      "Vídeos ilimitados",
      "Lançamentos ilimitados",
      "Compartilhamento sem limites",
      "Incorporação de vídeos do Youtube",
      "Link único para página",
      "Personalização de cores",
    ],
  },
  vipPlan: {
    name: "Vip",
    benefits: ["Crie até 5 páginas", "Utilize animações em seus componentes"],
  },
  platinumPlan: {
    name: "Platinum",
    benefits: [
      "Suporte especial e prioritário",
      "Crie quantas páginas quiser",
      "Aplique animações em seus componentes",
      "Agende quando seu componente ficará visível publicamente",
      "Analise como sua página está performando através de nossos analytics (cliques, carregamentos da página etc.)",
      "Insire seu próprio código Javascript personalizado em sua página",
    ],
  },
  benefits: "Benefícios",
  currency: "R$",
  year: "ano",
  purchase: "Adquirir",
  andWinAVipPlanFor: "e ganhe um plano VIP por",
  sorryThisIsNotAvailable: "Desculpe, isso ainda não está disponível",
  soon: "Em breve...",
  faq: {
    menu: "FAQ",
    title: "Perguntas Frequentes",
    description: "Encontre aqui as perguntas mais comuns que as pessoas fazem.",
    stillNeedHelp: "Ainda precisa de ajuda?",
  },
  createNowYourPage: "Faça agora sua página!",
  successUpdatePage: "Página atualizada com sucesso!",
  errorUpdatePage: "Falha ao atualizar a página.",
  successRemoveComponent: "Componente removido com sucesso!",
  errorRemoveComponent: "Falha ao remover componente.",
  successUpdateUser: "Usuário atualizado com sucesso!",
  errorUpdateUser: "Erro ao atualizar usuário.",
  sorry: "Desculpe",
  pagePreview: "Pré-visualização da página",
  buttonPreview: "Pré-visualização do botão",
  message: "Mensagem",
  messageExample:
    "Oi! Aqui é a Maria. Tudo bem? Estou entrando em contato porque tenho uma oportunidade de negócio para você!",
  errorSendingSupportContact: "Erro enviando email para o suporte.",
  successSendingSupportContact: "Mensagem enviada com sucesso!",
  errorRecaptchaValidation: "Você é um humano mesmo? Erro ao validar sua ação.",
  goToHomePage: "Ir para Página Inicial",
  goToPages: "Ir para minhas Páginas",
  webiseCreatedBy: "Site criado por",
  allRightsReserved: "Todos os direiros reservados",
  about: "Sobre",
  company: "Empresa",
  legal: "Legal",
  privacy: "Privacidade",
  deleteAccount: "Excluir conta",
  delete: "Excluir",
  deleteAccountSuccess: "Conta excluída com sucesso.",
  deleteAccountError: "Não foi possível excluir a conta.",
  plansBlockings: {
    yourPlanDoesntAllowCreateNewPage:
      "Seu plano não permite criar uma nova página",
    yourPlanDoesntAllowAnimation: "Seu plano não permite animações",
    yourPlanDoesntAllowComponentScheduling:
      "Seu plano não permite agendar componentes",
  },
  somethingWentWrong: "Ops! Algo deu errado!",
  testimonials: {
    testimonialsTitle: "Depoimentos",
    testimonialsSubtitle: "Alguns feedbacks que recebemos sobre nosso serviço",
    userTestimonials: "Meus depoimentos",
    testimonials: "Depoimentos",
    userTestimonialsSubtitle:
      "Confira aqui todos os depoimentos que você enviou",
    noTestimonials: "Sem depoimentos",
    createANewTestimonial: "Criar depoimento",
    editATestimonial: "Editar depoimento",
    zeroRatingDialogTitle: "Confirmar avaliação",
    deleteDialogTitle: "Confirmar exclusão",
    zeroRatingDialogText:
      "Deseja realmente avaliar o Pagefy com a nota 0 ou esqueceu de selecionar uma nota?",
    deleteDialogText: "Deseja realmente excluir seu depoimento?",
    leaveTestimonial: "Deixar depoimento",
  },
  yourGallery: "Sua galeria",
  fromYourGalleryOrTemplates: "Da sua galeria ou dos nossos templates",
  orUploadANewFile: "Ou envie uma nova imagem",
  orFromYourDevice: "Ou do seu dispositivo",
  componentBorderRadius: "Arredondamento das Bordas",
  borders: "Bordas",
  shadow: "Sombra",
  customScripts: {
    insertCustomScript: "Insira um código personalizado",
    customScriptDescription:
      "Use esses campos se você for um usuário avançado, para rodar código Javascript personalizado na sua página.",
    headerScript: "Script para o Header",
    endBodyScript: "Script para o final do body",
    scriptNotValidated: "Script não pôde ser validado",
  },
  personalData: "Dados Pessoais",
  finance: {
    title: "Financeiro",
    subtitle: "Encontre aqui seu histórico de pagamentos",
    profileTableHeaders: {
      plan: "Plano",
      startDate: "Início",
      endDate: "Fim",
      status: "Status",
    },
  },
  phoneNumber: "Telefone",
  color: "Cor",
  status: "Status",
  home2: {
    mainHeader: "Tudo o que você faz. Simples e direto.",
    mainSubheader: "Mostre para o mundo o conteúdo que só você sabe fazer.",
    buttonCreateFreeAccount: "Criar minha conta grátis agora",
    subscriptionFree: ["Faça sua assinatura", "agora"],
    areYouGonnaLoseIt: "Vai perder?",
    tripleTitles: [
      "Para você ou para sua empresa",
      "Recursos exclusivos e interativos",
    ],
    iconTextCards: [
      {
        title: "Mostre seus vídeos",
        subtitle:
          "Apresente seus vídeos mais importantes de uma forma rápida e simples",
      },
      {
        title: "Customize cores e layout",
        subtitle:
          "Deixe sua página com a sua cara, edite cores, imagens e componentes",
      },
      {
        title: "Compartilhe onde quiser",
        subtitle:
          "Mostre para todos os seus seguires o conteúdo incrível que você tem!",
      },
    ],
    section1: {
      title: "A melhor forma de compartilhar seu conteúdo",
      subtitle:
        "Acompanhe dados sobre seus links, agende eventos, mostre vídeos e direcione seu público para o conteúdo certo.",
      button: ["Obter assinatura", "agora!"],
    },
    section2: {
      title: "Gerencie todo o seu conteúdo de um só lugar.",
      chips: [
        "Comece com o plano Free",
        "Componentes ilimitados na página",
        "Cancelamento a qualquer momento",
      ],
    },
    section3: {
      title: "O que nossos clientes falam sobre a gente?",
    },
  },
  signInWith: "Entre com",
  congratulations: "Parabéns",
  accessDashboard: "Acessar dashboard",
  discountOf: "Desconto de",
  forMonthRecurrency: "para plano mensal",
  perYear: "ao ano",
  processingCheckout: "Processando checkout...",
  subscribeRedirectStripeDisclaimer:
    "Ao clicar em ASSINAR você será redirecionado para uma página externa do Stripe (meio de pagamento) e será redirecionado de volta após o pagamento.",
  endsAt: "Termina em",
  planFeatures: {
    whatYourPlanHas: "O que seu plano tem",
    analytics: "Analytics",
    customJs: "Javascript personalizado",
    animations: "Animações",
    launchDateComponent: "Componente com data de lançamento",
    maxPages: "Máximo de páginas",
    specialSupport: "Suporte especial",
    watermark: "Marca d'água",
  },
  understoodEverything: "Entendi tudo",
  onboardings: {
    userPages: {
      step1: "Clique aqui para criar uma página",
    },
    pageEditor: {
      general: {
        step1:
          "Nesta tela você pode editar a forma como sua página final parecerá, desde deverá ficar visível ao público, cores de fonte e fundo da página e dos componentes, poderá criar elementos como botões, ícones etc., poderá escolher a ordem em que seus componentes aparecem, dentre muitas outras coisas. \n\nSiga adiante para saber mais.",
        step2:
          "Aqui você pode alterar a foto principal, que aparece no topo da sua página.",
        step3:
          "Aqui você pode alterar o nome (que aparece logo abaixo da foto principal) e o link que as pessoas usarão para acessar sua página (precisa ser um nome ainda não utilizado na plataforma, conter apenas letras minúsculas, sem caracteres especiais (apenas hífens), exemplo: /este-e-meu-link).",
        step4:
          "Aqui você poderá criar os elementos que serão exibidos na sua página.",
        step5:
          "Aqui você pode escolher se sua página deve ficar pública (aberta para a internet) ou não.",
        step6:
          "Aqui você pode alterar a cor dos textos da sua página (exceto os textos dos elementos da página, que você pode configurar uma cor própria).",
        step7:
          "Aqui você pode alterar a cor de fundo da sua página (exceto dos fundos dos elementos da página, que você também pode configurar uma cor própria). Caso você envie uma imagem de fundo, esta cor não aparece.",
        step8:
          "Aqui você pode enviar uma imagem para o fundo da sua página (esconderá a cor de fundo, caso alguma tenha sido selecionada)",
        step9:
          "Caso seu plano permita e você seja um usuário avançado, aqui você pode inserir um código Javascript personalizado para sua página (códigos maliciosos serão removidos).",
        step10: "Caso queira excluir sua página, basta clicar aqui.",
        step11:
          "Abra sua página em outra aba para visualizar como ela realmente será exibida para seu público.",
      },
      createDialog: {
        step1:
          "Todos os elementos podem ser criados por aqui, basta selecionar qual deles você quer criar agora.",
      },
      createButton: {},
    },
  },
  validate: "Validar",
  couponApplied: "Cupom aplicado!",
  couponNotFound: "Cupom não existe",
};
